<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.cadastro.municipio"
        ref="RkmDataTable"
    >
        <template v-slot:cell(municipio_cep)="row">
            {{row.value | cep}}
        </template>
    </rkm-data-table>
</template>

<script>
// Formats.
import format from '@/utils/format'

export default {
    computed: {
        fields() {
            return [
                {key: 'pais_nome', label: 'País', name: 'cadastro_pais.nome', searchable: true, sortable: true},
                {key: 'estado_nome', label: 'Estado', name: 'cadastro_estado.nome', searchable: true, sortable: true},
                {key: 'estado_uf', label: 'Sigla', name: 'cadastro_estado.uf', searchable: true, sortable: true},
                {key: 'municipio_nome', label: 'Nome', name: 'cadastro_municipio.nome', searchable: true, sortable: true},
                {key: 'municipio_ibge', label: 'IBGE', name: 'cadastro_municipio.ibge', searchable: true, sortable: true},
                {key: 'municipio_cep', label: 'CEP', name: 'cadastro_municipio.cep'},
            ]
        },
    },
    filters: {
        cep: format.cep,
    },
    inject: ['repositories'],
}
</script>